<template>
  <div class="homepage">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in" :duration="{ enter: 500, leave: 300 }">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>
<script setup>


import { useStore } from 'vuex';
const store = useStore()
// 初始化数据

</script >
<style lang="less">
.sortDialogs {
  .el-dialog__body {
    padding: 5px !important;
  }
}

.homepage {
  background-color: #303133;
}

/*进度条 */
#nprogress .bar {
  /* 自定义颜色 需要加上!important;，这里加了渐变色 */
  background-color: #409EFF !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}


.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/*当页面最大宽小于1920 */
@media screen and (max-width: 1920px) {}

/*当页面最大宽小于400*/
@media only screen and (max-width: 450px) {
  .upDataLogDiaLog {
    transform: scale(0.8);
    width: auto !important;
  }
}
</style>
